import { freshItems } from '@/mocks/gossipData';
import { fmtWan } from './format';

export default function FreshList() {
  const maxHeat = Math.max(...freshItems.map((f) => f.heat));

  return (
    <section id="fresh" className="bg-background-100">
      <div className="mx-auto max-w-5xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-flashlight-line" />
              今日新料
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              猛料速递
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按热度实时排序，刚出炉的黑吃瓜新料都先停在这列大卡上。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1"><i className="ri-time-line" />最近更新 00:47</span>
            <span className="flex items-center gap-1"><i className="ri-signal-tower-line" />实时</span>
          </div>
        </div>

        <div className="mt-8 space-y-5">
          {freshItems.map((f, i) => (
            <article
              key={f.id}
              className="fade-up flex flex-col gap-5 rounded-2xl border border-background-200 bg-white p-5 transition-colors hover:border-primary-300 md:flex-row md:items-stretch md:p-6"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  {f.badge && (
                    <span className="rounded-md bg-primary-600 px-2 py-0.5 text-[10px] font-bold text-background-50">
                      {f.badge}
                    </span>
                  )}
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[10px] font-semibold text-secondary-800">
                    {f.circle}
                  </span>
                  <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[10px] font-semibold text-accent-800">
                    {f.tag}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-2xl">
                  {f.title}
                </h3>
                <p className="mt-2 hidden text-sm leading-relaxed text-foreground-600 sm:block">
                  {f.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-time-line" />{f.time}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line" />{f.comment} 条讨论</span>
                  <span className="flex items-center gap-1 text-primary-700"><i className="ri-fire-line" />热度 {fmtWan(f.heat)}</span>
                </div>
                <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-100">
                  <div
                    className="rise-bar h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                    style={{ width: `${(f.heat / maxHeat) * 100}%` }}
                  />
                </div>
              </div>
              {f.thumb && (
                <div className="relative shrink-0 overflow-hidden rounded-xl md:w-[210px]">
                  <img
                    src={f.thumb}
                    alt={f.title}
                    className="h-40 w-full object-cover object-top md:h-full"
                  />
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}